export const exactRoutes = routes => routes.map(
  route => ({
    ...route,
    exact: true
  })
);
